import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { useShipmentRateLabelRowStyles } from './shipment-rate-label-row.styles'

export type ShipmentRateLabelRowProps = {
  label: string
  children: React.ReactNode
}

/** Checkout row: bold fixed-width label + flexible value (rate summary or loader). */
export const ShipmentRateLabelRow: React.FC<ShipmentRateLabelRowProps> = ({
  label,
  children,
}): React.ReactElement => {
  const classes = useShipmentRateLabelRowStyles()

  return (
    <div className={classes.root}>
      <Typography
        component="div"
        variant="subtitle2"
        color="textPrimary"
        className={classes.label}
      >
        {label}
      </Typography>
      <Box className={classes.value}>{children}</Box>
    </div>
  )
}
